module.exports = __webpack_public_path__ + "img/c2.316da68d.png";